module.exports = __webpack_public_path__ + "1ebec7e45cbabf6d40c457df817a448f.jpg";